import React, { FC } from 'react'
import { Box } from '@material-ui/core'

const SelectGroup: FC = ({ children }) => {
  const validChildren = React.Children.toArray(children).filter(Boolean);

  return (
    <Box display="flex" alignItems="center">
      {validChildren.map((child, i) => {
        const childrenNew = child as React.ReactElement

        return React.cloneElement(childrenNew, {
          smoothLeft: i !== 0,
          smoothRight: i !== validChildren.length - 1,
        })
      })}
    </Box>
  )
}

export default SelectGroup
